import { RegularNode, SchemaNode } from '@stoplight/json-schema-tree';
import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';


export const hoveredNodeAtom = atom<SchemaNode | null>(null);

export const isNodeHoveredAtom = atomFamily((node: SchemaNode) => atom(get => node === get(hoveredNodeAtom)));

export const isChildNodeHoveredAtom = atomFamily((parent: SchemaNode) =>
  atom(get => {
    const hoveredNode = get(hoveredNodeAtom);

    if (!hoveredNode || hoveredNode === parent) return false;

    return hoveredNode.parent === parent;
  }),
);

export const sourceAtomFamily = atomFamily(
  (propertyPath: string) => atom<string | undefined>(undefined)
);

export const sourceDataObject: any = {}

export const resetSourceDataObject = () => {
  Object.keys(sourceDataObject).forEach(key => delete sourceDataObject[key]);
};

export const updateWithPath = (path: string, value: string) => {
  sourceDataObject[path] = value;
}

export const updateDataObject = (node: SchemaNode, value: string, key: string = "") => {

  const jsonPath = `${key}.${modifyDataObject(node, [])}`;
  sourceDataObject[jsonPath] = value;

  // console.log('---------->>>sourceDataObject ', sourceDataObject)

}

export const modifyDataObject = (node: SchemaNode, path: string[]): any => {
  node.subpath[1] && path.push(node.subpath[1]);

  if (node.parent?.subpath.length !== 0) {
    return modifyDataObject(node.parent as RegularNode, path)
  }

  return path.reverse().join('.');
}
